import Marquee from "react-fast-marquee";

export default function OutlineMarquee({ words = [], speed = 40, light = false }) {
  return (
    <div className="py-4 select-none" aria-hidden="true">
      <Marquee speed={speed} gradient={false}>
        {words.map((w, i) => (
          <span
            key={i}
            className={`font-display text-6xl lg:text-8xl font-black tracking-tightest mx-8 ${light ? "outline-text-light" : "outline-text"}`}
          >
            {w}
            <span className="text-[#F36F21] mx-8" style={{ WebkitTextStroke: "0" }}>·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
